module.exports = __webpack_public_path__ + "assets/img/3.07e2fdcd.jpg";